import { Alert, AlertDescription, AlertTitle } from "@atoms/Alert";
import { useAuthStore } from "@/hooks/AuthStore";
import { AlertCircle } from "lucide-react";

const SessionExpiredAlert = () => {
  const expired = useAuthStore(({ expired }) => expired);

  if (!expired) return null;

  return (
    <Alert variant="orange">
      <AlertCircle className="h-5 w-5 stroke-white" />
      <AlertTitle className="ml-2">Session expirée</AlertTitle>
      <AlertDescription className="font-normal ml-2">
        Reconnectez vous pour accéder à votre compte.
      </AlertDescription>
    </Alert>
  );
};

export default SessionExpiredAlert;
